import React from 'react';
import c from 'classnames';

import { useTranslation } from '@lyearn/i18n';
import { Box, Image, Typography } from '@lyearn/ui';

import { ListItemProps } from './types';

const ListItem: React.FC<ListItemProps> = (props) => {
  const { flag, label, languageLabel, disabled, className } = props;
  const { t } = useTranslation();

  return (
    <Box className={className}>
      <Image alt={languageLabel} className="rounded-[1px]" height={18} src={flag} width={24} />
      <Typography
        className={c('ms-8 me-6', disabled ? 'text-disabled' : 'text-text-primary')}
        variant="body-short-02">
        {t(label)}
      </Typography>
      &bull;
      <Typography
        className={c('ms-6', disabled ? 'text-disabled' : 'text-text-secondary')}
        variant="body-short-02">
        {languageLabel}
      </Typography>
    </Box>
  );
};

export default ListItem;
